import { render, staticRenderFns } from "./DropdownToGo.vue?vue&type=template&id=11d4daa1"
import script from "./DropdownToGo.vue?vue&type=script&lang=js"
export * from "./DropdownToGo.vue?vue&type=script&lang=js"
import style0 from "./DropdownToGo.vue?vue&type=style&index=0&id=11d4daa1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports